'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifiersForComponent = modifiersForComponent;

var _lodash = require('lodash');

// This will split up/ apply only the correct modifiers
// to the internally rendered components.
// eslint-disable-next-line import/prefer-default-export
function modifiersForComponent(modifiers, Component) {
  if (Component.modifiers) {
    return (0, _lodash.intersection)(Object.keys(Component.modifiers), modifiers);
  }
  return [];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/utils/modifiers.js
// module id = 71
// module chunks = 2